"use client";

import { Banner } from "@/common/Banner";
import AnmeldenSection from "./AnmeldenSection";

function Page() {
  return (
    <div className="Anmelden">
      <AnmeldenSection />
      <Banner removeContent className="Banner-anmelden" />
    </div>
  );
}

//test deployment
export default Page;
